module.exports = __webpack_public_path__ + "img/delta_kitten.eb87b540.jpeg";